export default "__VITE_ASSET__MX_FEO2W__"